  /**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevicesRoutingModule } from './devices-routing.module';
import { CreateDeviceComponent } from './create-device/create-device.component';
import { ManageDeviceComponent } from './manage-device/manage-device.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateGroupComponent } from './create-group/create-group.component';
import { ManageGroupComponent } from './manage-group/manage-group.component';
import { ConfigureDeviceComponent } from './configure-device/configure-device.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GroupDetailsComponent } from './group-details/group-details.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DeviceTunnelingComponent } from './device-tunneling/device-tunneling.component';
import { DeviceSimMappingComponent } from './device-sim-mapping/device-sim-mapping.component';
import { DeviceStatisticsComponent } from './device-statistics/device-statistics.component';
import { SystemApplicationGraphsComponent } from './system-application-graphs/system-application-graphs.component';
import { C2dMethodComponent } from './c2d-method/c2d-method.component';
import { ApplicationGraphsComponent } from './application-graphs/application-graphs.component';

/**
  * @ngdoc overview
  * @name MODULE_NAME.module:DevicesModule
  *
  * @description
  * This module has the information of feature modules, Angular material modules, external modules and
    the components that belong to this module
  *
*/
@NgModule({
  declarations: [CreateDeviceComponent, ManageDeviceComponent, CreateGroupComponent, ManageGroupComponent,
    ConfigureDeviceComponent,
    GroupDetailsComponent,
    DeviceTunnelingComponent,
    DeviceSimMappingComponent,
    DeviceStatisticsComponent,
    SystemApplicationGraphsComponent,
    C2dMethodComponent,
    ApplicationGraphsComponent],
  imports: [
    CommonModule,
    DevicesRoutingModule,
    TranslateModule,
    SharedModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatCardModule,
    MatMenuModule,
    FormsModule,
    MatSliderModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatProgressBarModule
  ]
})
export class DevicesModule { }
